import { Contact } from '@/app/network/models/contact';
import { AddressDisplayValue } from '@/common/components/address-display-value';
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '@/common/components/description-list';
import { DisplayValue } from '@/common/components/display-value';
import { DeleteContact } from '@/contacts/components/delete-contact';

export function ContactView({ contact }: { contact: Contact }) {
  return (
    <DescriptionList>
      <DescriptionTerm>Client</DescriptionTerm>
      <DescriptionDetails><DisplayValue value={contact.client?.name} /></DescriptionDetails>

      <DescriptionTerm>Title</DescriptionTerm>
      <DescriptionDetails><DisplayValue value={contact.title} /></DescriptionDetails>

      <DescriptionTerm>Email</DescriptionTerm>
      <DescriptionDetails><DisplayValue value={contact.email} /></DescriptionDetails>

      <DescriptionTerm>Work Phone</DescriptionTerm>
      <DescriptionDetails><DisplayValue value={contact.workPhone} /></DescriptionDetails>

      <DescriptionTerm>Mobile Phone</DescriptionTerm>
      <DescriptionDetails><DisplayValue value={contact.mobilePhone} /></DescriptionDetails>

      <DescriptionTerm>Address</DescriptionTerm>
      <DescriptionDetails>
        <AddressDisplayValue
          addressLine1={contact.addressLine1}
          addressLine2={contact.addressLine2}
          city={contact.city}
          state={contact.state}
          zipCode={contact.zipCode}
        />
      </DescriptionDetails>

      <DescriptionTerm className="text-red-600 dark:text-red-400">Danger Zone</DescriptionTerm>
      <DescriptionDetails>
        <DeleteContact contactId={contact.id} />
      </DescriptionDetails>
    </DescriptionList>
  );
}
